import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// utils/getFotoUrl.ts
export const getFotoUrl = (foto: string | undefined): string => `https://proxy-intra.feagri.unicamp.br/files/${foto}`;
